// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingF":"IndustryLeadingF_IndustryLeadingF__PYZ9k"};